import PageLoader from "@/services/pageLoader";
import Default from "@/layouts/Default";

import { mapActions } from "vuex";

export default (strategy, options) => {
  return {
    components: {
      Default
    },
    methods: {
      ...mapActions({
        setErrorCode: "page/setErrorCode",
        setStatus: "page/setStatus"
      })
    },
    async beforeRouteEnter(to, from, next) {
      if (strategy) {
        PageLoader.run.call(this, {
          strategy,
          options,
          route: to,
          done: next
        });
      } else {
        next();
      }
    },
    async beforeRouteUpdate(to, from, next) {
      if (strategy) {
        PageLoader.run.call(this, {
          strategy,
          options,
          type: "update",
          route: to,
          done: next
        });
      } else {
        next();
      }
    }
  };
};
